// extracted by mini-css-extract-plugin
export default {"model":"Model_model__YPGOv","model__view":"Model_model__view__3V9st"};